(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-rating"] && !Shopify.designMode) return;
  try {
    
  const counters = document.querySelectorAll('.counter-rating');

const animateCounter = (el) => {
  const target = parseFloat(el.getAttribute('data-target'));
  const duration = 1500; // total time in ms
  const startTime = performance.now();

  const update = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const value = (progress * target).toFixed(1);
    el.textContent = value;
    
    if (progress < 1) {
      requestAnimationFrame(update);
    } else {
      el.textContent = target.toFixed(1); // Ensure final value is exact
    }
  };

  requestAnimationFrame(update);
};

const observer = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateCounter(entry.target);
      obs.unobserve(entry.target);
    }
  });
}, { threshold: 0.6 });

counters.forEach(counter => observer.observe(counter));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-advantages"] && !Shopify.designMode) return;
  try {
    
  const pulseElements = document.querySelectorAll('.img-pulse');
let index = 0;

function pulse(el) {
  el.style.transition = 'transform 0.6s ease-in-out';
  el.style.transform = 'scale(1.2)';

  setTimeout(() => {
    el.style.transform = 'scale(1)';

    setTimeout(() => {
      index = (index + 1) % pulseElements.length;
      pulse(pulseElements[index]);
    }, 400); // delay before next pulse starts
  }, 600); // time at scale(1.2)
}

// Start the loop
if (pulseElements.length > 0) {
  pulse(pulseElements[index]);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-our-journey"] && !Shopify.designMode) return;
  try {
    
  const counters = document.querySelectorAll('.counter');

  const animateCounter = (el) => {
    const target = +el.getAttribute('data-target');
    const duration = 1500; // total time in ms
    const startTime = performance.now();

    const update = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      el.textContent = Math.floor(progress * target);
      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = target; // Final value
      }
    };

    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6 });

  counters.forEach(counter => observer.observe(counter));

  } catch(e) { console.error(e); }
})();
})();
